// PHCDashboardSaga.js

import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  PHCDashboardConstants,
} from "./PHCDashboardConstants";

import { PHCDashboardApis } from "./PHCDashboardApis";
import { PHCDashboardAction } from "./PHCDashboardAction";



// Worker Saga
function* fetchPortfolioSaga() {
  try {
    const response = yield call(PHCDashboardApis.getList);
    yield put(PHCDashboardAction.fetchPortfolioSuccess(response.result));  // your JSON response
  } catch (error) {
    yield put(PHCDashboardAction.fetchPortfolioFailure(error.message));
  }
}

// Watcher Saga
export function* PHCDashboardSaga() {
  yield takeLatest(PHCDashboardConstants.FETCH_PORTFOLIO_REQUEST, fetchPortfolioSaga);
}
